import request from '@/utils/request'
import type { DailyCloseProductHead, DailyCloseProductItem, DailyCloseProductItemSearch, DailyCloseProductSearch } from './types'

export const DAILY_CLOSE_PRODUCT_HEADS_URL = '/api/v1/get-daily-close-product-heads'
export const DAILY_CLOSE_PRODUCT_HEADS_EXCEL_URL = `${DAILY_CLOSE_PRODUCT_HEADS_URL}/excel`
export const DAILY_CLOSE_PRODUCT_ITEMS_URL = '/api/v1/get-daily-close-product-items'
export const DAILY_CLOSE_PRODUCT_ITEMS_EXCEL_URL = `${DAILY_CLOSE_PRODUCT_ITEMS_URL}/excel`

/** 정의된 조회 조건만 요청 body에 담고 비어 있는 선택 조건은 제외한다. */
const toCommonBody = (params: DailyCloseProductSearch): DailyCloseProductSearch => ({
  ...(params.shipperCode ? { shipperCode: params.shipperCode } : {}),
  closeDateFrom: params.closeDateFrom,
  closeDateTo: params.closeDateTo,
  ...(params.brandName ? { brandName: params.brandName } : {}),
  ...(params.goodsCode ? { goodsCode: params.goodsCode } : {}),
  ...(params.barcodes?.length ? { barcodes: params.barcodes } : {}),
  ...(params.logisticsServiceType ? { logisticsServiceType: params.logisticsServiceType } : {}),
})

export const getDailyCloseProductHeads = (params: DailyCloseProductSearch): Promise<ApiResponseV2<{ items: DailyCloseProductHead[] }>> =>
  request.post<ApiResponseV2<{ items: DailyCloseProductHead[] }>, DailyCloseProductSearch>(DAILY_CLOSE_PRODUCT_HEADS_URL, toCommonBody(params))

export const getDailyCloseProductItems = (params: DailyCloseProductItemSearch): Promise<ApiResponseV2<ApiPageResponse<DailyCloseProductItem>>> => {
  const body: DailyCloseProductItemSearch = {
    ...toCommonBody(params),
    shipperCode: params.shipperCode,
    warehouseName: params.warehouseName,
    page: params.page,
    pageSize: params.pageSize,
  }
  return request.post<ApiResponseV2<ApiPageResponse<DailyCloseProductItem>>, DailyCloseProductItemSearch>(DAILY_CLOSE_PRODUCT_ITEMS_URL, body)
}
